import React from 'react';
import TextField from '@material-ui/core/TextField';
import useStyles from './styles';

const RTVSelect = ({ children, ...props }) => {
  const classes = useStyles();
  return (
    <TextField
      {...props}
      variant="outlined"
      InputProps={{
        classes: {
          root: classes.inputs
        }
      }}
      SelectProps={{
        classes: {
          root: classes.select
        },
        MenuProps: {
          classes: {
            paper: classes.menuPaper
          }
        }
      }}
      InputLabelProps={{
        classes: {
          root: classes.label
        }
      }}
      select
    >
      {children}
    </TextField>
  );
};

export default RTVSelect;
